import { PopoverVirtualElement } from '@mui/material';
import { useState, MouseEvent, useCallback } from 'react';

interface UseButtonMenuResult {
  popoverProps: {
    open: boolean;
    anchorEl?: null | Element | (() => Element) | PopoverVirtualElement | (() => PopoverVirtualElement);
    onClose: () => void;
  };
  triggerProps: {
    onClick: (event: MouseEvent<HTMLElement>) => void;
  };
}

export const usePopover = (): UseButtonMenuResult => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return {
    triggerProps: {
      onClick: handleMenuOpen,
    },
    popoverProps: {
      open,
      anchorEl,
      onClose: handleMenuClose,
    },
  };
};
